import { render, staticRenderFns } from "./customerOrigin.vue?vue&type=template&id=44cb4a34&scoped=true&"
import script from "./customerOrigin.vue?vue&type=script&lang=js&"
export * from "./customerOrigin.vue?vue&type=script&lang=js&"
import style0 from "./customerOrigin.vue?vue&type=style&index=0&id=44cb4a34&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cb4a34",
  null
  
)

export default component.exports